import { inject, Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import * as config from '../shared/config/app.config';
import { BaseService } from "../shared/services/base.service";
import { CustomAuthService } from '../custom-auth-service.service';
import { AuthActions, FeatureConfigService, OCC_USER_ID_CURRENT, OccEndpointsService, StateWithClientAuth, UserIdService } from '@spartacus/core';
import { Store } from '@ngrx/store';
import { VscaOAuthLibWrapperService } from '../../core/auth/user-auth/service/vsca-oauth-lib-wrapper.service';

@Injectable({
  providedIn: 'root',
})
export class ForgotUserPasswordService {
  private featureConfigService = inject(FeatureConfigService);

  public validateEmail = new BehaviorSubject(null);
  validateEmail$ = this.validateEmail.asObservable();
  public validateAnswer = new BehaviorSubject(null);
  validateAnswer$ = this.validateAnswer.asObservable();
  public userData = new BehaviorSubject(null);
  userData$ = this.userData.asObservable();
  public resetPasswordResponse = new BehaviorSubject(null);
  reserPasswordResponse$ = this.resetPasswordResponse.asObservable();
  baseSite: string;

  constructor(
    private readonly oAuthLibWrapperService: VscaOAuthLibWrapperService,
    private readonly userIdService: UserIdService,
    private readonly store: Store<StateWithClientAuth>,
    public readonly baseService: BaseService,
    private readonly authService: CustomAuthService,
    private readonly occEndPoint: OccEndpointsService,
  ) {}

  public validateEmailId(params) {
    this.baseService.post(config.VALIDATE_EMAIL, params).subscribe(
      (res) => {
        this.userData.next(params);
        this.validateEmail.next(res);
      },
      (err) => {
        this.userData.next(params);
        this.validateEmail.next(err);
      }
    );
  }

  public validatePasswordAnswer(answer) {
    this.baseService.post(config.VALIDATE_PASSWORD_ANSWER, answer).subscribe(
      (res) => {
        this.validateAnswer.next(res);
      },
      (err) => {
        this.validateAnswer.next(err);
      }
    );
  }

  public resetPassword(params) {
    this.baseService.post(config.RESET_PASSWORD, params).subscribe(
      (res) => {
        this.resetPasswordResponse.next(res);
      },
      (err) => {
        this.resetPasswordResponse.next(err);
      }
    );
  }

  public loginWithCredentials(userId: string, password: string) {
    if (this.featureConfigService.isEnabled('authorizationCodeFlowByDefault')) {
      this.authService.loginWithRedirect();

      return;
    }

    this.baseSite = this.occEndPoint.getBaseUrl({
      baseUrl: false,
      prefix: false,
      baseSite: true,
    });
    this.oAuthLibWrapperService
      .vscaAuthorizeWithPasswordFlowForbaseSiteId(userId, password, this.baseSite)
      .then(() => {
        this.userIdService.setUserId(OCC_USER_ID_CURRENT);
        this.store.dispatch(new AuthActions.Login());
      });
  }
}
